import { NEW_PRESCRIPTION_AND_UPLOAD, NEW_PRESCRIPTION, PRESCRIPTION_FILE, EMAIL_PRESCRIPTION, EXISTING_CUSTOMER } from "../../state/state/constants.js";
const convertCmsRxEntries = (entryTypes) => {
  if (!entryTypes) return;
  const ConversionMap = {
    "existing-customer": EXISTING_CUSTOMER,
    email: EMAIL_PRESCRIPTION,
    "file-upload": PRESCRIPTION_FILE,
    "form-entry": NEW_PRESCRIPTION,
    "form-upload": NEW_PRESCRIPTION_AND_UPLOAD,
    "book-appointment": "book-appointment"
  };
  return entryTypes.map((item) => ({ ...item, key: ConversionMap[item.key] }));
};
export {
  convertCmsRxEntries
};
//# sourceMappingURL=convert-cms-rx-entries.js.map
